<template>
	<div>
		<div
			v-for="(team, index) in allTeams"
			:key="index"
		>
			<h2>{{team.name}}</h2>
			<TeamAgenda
				:allShiftsList="allShiftsList"
				:teamMembersById="team.membersById"
			></TeamAgenda>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import TeamAgenda from './TeamAgenda';

	export default {
		name: 'AllTeamAgendas',
		components: {
			TeamAgenda,
		},

		data: () => ({
			allTeams: null,
		}),
		props: ['allShiftsList', 'userData'],
		watch: {
			userData: {
				immediate: true,
				async handler() {
					console.log('have userData', this.userData);
					if (this.userData.isOrga) {
						console.log('is orga');
						const allTeams = (await axios.get(`/teams`)).data.sort((a, b) => a.name > b.name ? 1 : -1);
						console.log('allTeams', allTeams);
						allTeams.forEach(team => {
							team.membersById = Object.fromEntries(team.members.map(m => [m.id, m]));
						});
						this.allTeams = allTeams;
					}
				},
			},
		},
		computed: {
		},
		created: function() {
		},
		methods: {
		}

	}
</script>

<style scoped>
	@media print {
		table {
			break-after: page;
		}
	}
</style>
